import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { UserAccessService } from './user-access.service';
import { ToastService } from './toast.service';
import { LimegearAuthenticationService } from '../../login/services/limegear-authentication.service';
import { CurrentUserStateService } from './current-user-state.service';
import { ImpersonationService } from './impersonation.service';

@Injectable({
    providedIn: 'root',
})
export class AuthGuardService {
    path: string;
    returnValue: boolean;

    constructor(
        private router: Router,
        private userAccessService: UserAccessService,
        private toastService: ToastService,
        private currentUserStateService: CurrentUserStateService,
        private limegearAuthService: LimegearAuthenticationService,
        private impersonationService: ImpersonationService
    ) {}

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean> | Promise<boolean> | boolean {
        this.returnValue = false;
        this.path = state.url;

        let returnValuePromise = new Promise<boolean>((resolve) => {
            this.limegearAuthService.isLoggedIn().then((loggedIn) => {
                if (loggedIn) {
                    this.handleLoggedInUser(route);
                } else {
                    this.router.navigate(['/login'], {
                        queryParams: {
                            redirect: this.path,
                        },
                    });

                    this.returnValue = false;
                }
                resolve(this.returnValue);
            });
        });

        return returnValuePromise;
    }

    handleLoggedInUser(route: ActivatedRouteSnapshot) {
        if (this.path === '/login') {
            this.router.navigate(['/home']);
            this.returnValue = true;
        } else {
            if (
                (this.currentUserStateService.isLBASuperUser() &&
                    !this.impersonationService.impersonateUser) ||
                this.path === '/home' ||
                this.path.startsWith('/home/alert-notification')
            ) {
                this.returnValue = true;
            } else {
                this.returnValue = this.userAccessService.hasAccessToPage(this.path, route);
            }
        }
    }
}
